import { createModulePromptRegistry } from '../../application/composer/modulePromptRegistry.js';

function normalizeText(value) {
  return String(value || '').trim();
}

function normalizeMatchText(value) {
  return normalizeText(value).toLowerCase();
}

function firstText(values = []) {
  return (Array.isArray(values) ? values : [])
    .map((item) => normalizeText(item))
    .find(Boolean) || '';
}

function matchesInput(inputValue = '', keywords = []) {
  const normalizedInput = normalizeMatchText(inputValue);
  if (!normalizedInput) {
    return '';
  }
  return (Array.isArray(keywords) ? keywords : [])
    .map((keyword) => normalizeMatchText(keyword))
    .find((keyword) => keyword && normalizedInput.includes(keyword)) || '';
}

function buildTipAction(entry = {}, matchedKeyword = '') {
  const modeKey = firstText(entry.targetModes) || normalizeText(entry.key);
  const command = firstText(entry.actionCommands);
  const actionText = normalizeText(entry.actionText) || normalizeText(entry.label) || '开启';
  if (!modeKey) {
    return null;
  }
  return {
    key: `composer-input-tip:${entry.key}`,
    text: actionText,
    description: normalizeText(entry.reason),
    source: 'composer_input_trigger',
    matchedKeyword,
    action: {
      action_type: 'switch_mode',
      type: 'switch_mode',
      target_mode: modeKey,
      ...(command ? { command, action_key: command } : {}),
    },
  };
}

export function selectComposerInputTip({
  inputValue,
  activeModeKey,
  modulePromptRegistry,
} = {}) {
  const registry = createModulePromptRegistry(modulePromptRegistry);
  const normalizedActiveMode = normalizeText(activeModeKey);
  const action = registry
    .map((entry) => ({ entry, matchedKeyword: matchesInput(inputValue, entry.triggerKeywords) }))
    .filter(({ matchedKeyword }) => Boolean(matchedKeyword))
    .map(({ entry, matchedKeyword }) => buildTipAction(entry, matchedKeyword))
    .filter(Boolean)
    .find((item) => normalizeText(item.action?.target_mode) !== normalizedActiveMode) || null;
  if (!action) {
    return null;
  }
  const modeKey = normalizeText(action.action?.target_mode);
  const entry = registry.find((item) => normalizeText(item.key) === modeKey || item.targetModes.includes(modeKey)) || {};
  return {
    key: action.key,
    roundKey: '',
    modeSuggestion: {
      source: 'composer_input_trigger',
      modeKey,
      label: normalizeText(entry.label) || modeKey,
      reason: action.description,
    },
    modeSuggestionAction: action,
    modeSuggestionActions: [action],
  };
}

export default selectComposerInputTip;
